import React from 'react';
import Skeleton from "@material-ui/lab/Skeleton";

const SkeletonText = () => {
  return (
    <div>
                   <div style={{ display:'flex'}}>
                  <Skeleton height={20} width="50%" style={{ marginBottom: 25  , marginTop: 5 , borderRadius:10,}}  />  <Skeleton width="45%"  variant="rect" style={{ marginLeft: 90 ,marginBottom: 25 ,  borderRadius:13 }}  />
                    </div>
                    <div style={{ display:'flex'}}>
                  <Skeleton height={20} width="50%" style={{ marginBottom: 25  , marginTop: 5 , borderRadius:10,}}  />  <Skeleton width="45%"  variant="rect" style={{ marginLeft: 90 ,marginBottom: 25 ,  borderRadius:13 }}  />
                    </div>
                    <div style={{ display:'flex'}}>
                  <Skeleton height={20} width="50%" style={{ marginBottom: 25  , marginTop: 5 , borderRadius:10,}}  />  <Skeleton width="45%"  variant="rect" style={{ marginLeft: 90 ,marginBottom: 25 ,  borderRadius:13 }}  />
                    </div>
                    <div style={{ display:'flex'}}>
                  <Skeleton height={20} width="50%" style={{ marginBottom: 25  , marginTop: 5 , borderRadius:10,}}  />  <Skeleton width="45%"  variant="rect" style={{ marginLeft: 90 ,marginBottom: 25 ,  borderRadius:13 }}  />
                    </div>
                    <div style={{ display:'flex'}}>
                  <Skeleton height={20} width="50%" style={{ marginBottom: 25  , marginTop: 5 , borderRadius:10,}}  />  <Skeleton width="45%"  variant="rect" style={{ marginLeft: 90 ,marginBottom: 25 ,  borderRadius:13 }}  />
                    </div>
                    <div style={{ display:'flex'}}>
                  <Skeleton height={20} width="50%" style={{ marginBottom: 25  , marginTop: 5 , borderRadius:10,}}  />  <Skeleton width="45%"  variant="rect" style={{ marginLeft: 90 ,marginBottom: 25 ,  borderRadius:13 }}  />
                    </div>
                    <div style={{ display:'flex'}}>
                  <Skeleton height={20} width="50%" style={{ marginBottom: 25  , marginTop: 5 , borderRadius:10,}}  />  <Skeleton width="45%"  variant="rect" style={{ marginLeft: 90 ,marginBottom: 25 ,  borderRadius:13 }}  />
                    </div>
                    <div style={{ display:'flex'}}>
                  <Skeleton height={20} width="50%" style={{ marginBottom: 25  , marginTop: 5 , borderRadius:10,}}  />  <Skeleton width="45%"  variant="rect" style={{ marginLeft: 90 ,marginBottom: 25 ,  borderRadius:13 }}  />
                    </div>
                    <div style={{ display:'flex'}}>
                  <Skeleton height={20} width="50%" style={{ marginBottom: 25  , marginTop: 5 , borderRadius:10,}}  />  <Skeleton width="45%"  variant="rect" style={{ marginLeft: 90 ,marginBottom: 25 ,  borderRadius:13 }}  />
                    </div>
                    <div style={{ display:'flex'}}>
                  <Skeleton height={20} width="50%" style={{ marginBottom: 25  , marginTop: 5 , borderRadius:10,}}  />  <Skeleton width="45%"  variant="rect" style={{ marginLeft: 90 ,marginBottom: 25 ,  borderRadius:13 }}  />
                    </div>
    </div>
  );
};


export default SkeletonText;